export default {
  COPY_CUSTOM_COLORS_CSS_RULES_FOR_BLOCKS:
    '@WS_EDITOR/WEBSITE_DESIGN/COPY_CUSTOM_COLORS_CSS_RULES_FOR_BLOCKS',
  REMOVE_CUSTOM_COLORS_CSS_RULES_FOR_BLOCKS:
    '@WS_EDITOR/WEBSITE_DESIGN/REMOVE_CUSTOM_COLORS_CSS_RULES_FOR_BLOCKS',
  CLEAN_UP_CUSTOM_COLORS_FROM_ACTIVE_PAGE:
    '@WS_EDITOR/WEBSITE_DESIGN/CLEAN_UP_CUSTOM_COLORS_FROM_ACTIVE_PAGE',
};
